<template>
  <div class="card">
    <h5 class="card-header text-truncate w-100">
      <span class="badge bg-info rounded-pill bx-pull-right font-size-12">
        Estados
      </span>
      Instalaciones
    </h5>
    <div class="card-body">
      <div class="row">
        <div class="col-4 text-center">
          <router-link
            :to="{
              name: 'listadoSolicitudesInstalacion',
              query: { estado: 1, todos: true }
            }"
            title="Pendientes"
          >
            <div class="avatar mx-auto">
              <div
                class="avatar-title rounded-circle bg-warning bg-gradient"
                :class="pendientes <= 999 ? 'font-size-20' : 'font-size-16'"
                :title="pendientes"
              >
                {{ pendientesFormato }}
              </div>
            </div>
            <div class="text-warning text-truncate w-100">
              Pendientes
            </div>
          </router-link>
        </div>
        <div class="col-4 text-center">
          <router-link
            :to="{
              name: 'listadoSolicitudesInstalacion',
              query: { estado: 2, todos: true }
            }"
            title="En procesos"
          >
            <div class="avatar mx-auto">
              <div
                class="avatar-title rounded-circle bg-info bg-gradient"
                :class="proceso <= 999 ? 'font-size-20' : 'font-size-16'"
                :title="proceso"
              >
                {{ procesoFormato }}
              </div>
            </div>
            <div class="text-info text-truncate w-100">
              En procesos
            </div>
          </router-link>
        </div>

        <div class="col-4 text-center">
          <router-link
            :to="{ name: 'listadoSolicitudesInstalacion' }"
            title="Solicitudes de instalación"
          >
            <div class="avatar mx-auto">
              <div class="avatar-title rounded-circle bg-primary bg-gradient font-size-20">
                <i class="mdi mdi-tools"></i>
              </div>
            </div>
            <div class="text-truncate w-100">
              Instalaciones
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SolicitudInstalacionSrv from '@/services/SolicitudInstalacionSrv.js'

export default {
  name: 'WInstalaciones',
  data() {
    return {
      pendientes:   sessionStorage.getItem('argusblack.winstalaciones.pendientes')   || 0,
      proceso:      sessionStorage.getItem('argusblack.winstalaciones.proceso')      || 0,
      intervals: {
        actualizacion: null
      }
    }
  },
  created() {
    var self = this

    this.actualizar()
    this.intervals.actualizacion = setInterval(function() {
      self.actualizar()
    }, 60000)
  },
  computed: {    
    pendientesFormato: function() {
      return this.pendientes <= 9999 ? this.pendientes : '999+'
    },
    procesoFormato: function() {
      return this.proceso <= 9999 ? this.proceso : '999+'
    }
  },
  beforeUnmount() {
    clearInterval(this.intervals.actualizacion)
  },
  methods: {
    actualizar() {
      var self = this
      let params = { mes_actual: true }      

      SolicitudInstalacionSrv.nPendientes(params).then(response => {
        self.pendientes = response.data
        sessionStorage.setItem('argusblack.winstalaciones.pendientes', self.pendientes)
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje):null
        console.log(error)
      })

      SolicitudInstalacionSrv.nEnProceso(params).then(response => {
        self.proceso = response.data
        sessionStorage.setItem('argusblack.winstalaciones.proceso', self.proceso)
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje):null
        console.log(error)
      })
    }
  }
}
</script>